import React, { useState } from 'react';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import { MdAdd } from 'react-icons/md';
import '../Styles/UserTypes.css';
import '../Styles/PopupModal.css';
import { useSidebar } from '../Layout/SidebarContext';

const Solutions = () => {
  const { isConfigOpen } = useSidebar();

  const [solutions, setSolutions] = useState([
    {
      id: 1,
      name: 'Greenfield landing zone solution',
      description: 'Description of Solution',
      createdBy: 'Mohan',
      createdDate: '15-Mar-2021',
      editedBy: 'Ameena',
      editedDate: '13-Jun-2024',
    },
    {
      id: 2,
      name: 'Landing zone and tower migration',
      description: 'Description of Solution',
      createdBy: 'Ananya',
      createdDate: '12-Jan-2022',
      editedBy: 'Chandini',
      editedDate: '10-Jun-2024',
    },
  ]);

  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [solutionsInput, setSolutionsInput] = useState(['']);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [editName, setEditName] = useState('');
  const [editDescription, setEditDescription] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  const handleAddNew = () => setIsModalOpen(true);

  const handleModalClose = () => {
    setSolutionsInput(['']);
    setIsModalOpen(false);
  };

  const handleSaveNew = () => {
    if (solutionsInput.length > 0) {
      const newSolutions = solutionsInput.map((solution) => ({
        id: solutions.length + 1,
        name: solution,
        description: 'New Solution',
        createdBy: 'Admin',
        createdDate: new Date().toLocaleDateString(),
        editedBy: 'Admin',
        editedDate: new Date().toLocaleDateString(),
      }));

      setSolutions([...solutions, ...newSolutions]);
      setSolutionsInput(['']);
      setIsModalOpen(false);
    }
  };

  const handleEditSolution = (index) => {
    const solution = solutions[index];
    setEditName(solution.name);
    setEditDescription(solution.description);
    setEditIndex(index);
    setEditModalOpen(true);
  };

  const handleSaveEdit = () => {
    const updatedSolutions = [...solutions];
    updatedSolutions[editIndex] = {
      ...updatedSolutions[editIndex],
      name: editName,
      description: editDescription,
      editedBy: 'Admin',
      editedDate: new Date().toLocaleDateString(),
    };
    setSolutions(updatedSolutions);
    setEditModalOpen(false);
  };

  const handleDeleteSolution = (index) => {
    setDeleteIndex(index);
    setConfirmDelete(true);
  };

  const handleConfirmDelete = () => {
    const newSolutions = solutions.filter((_, index) => index !== deleteIndex);
    setSolutions(newSolutions);
    setConfirmDelete(false);
    setDeleteIndex(null);
  };

  const handleCancelDelete = () => {
    setConfirmDelete(false);
    setDeleteIndex(null);
  };

  const filteredSolutions = solutions.filter(
    (solution) =>
      solution.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      solution.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className={`user-types-container ${isConfigOpen ? 'shifted-right' : ''}`}>
      <div className='heading'>
        <h2>Manage Solutions</h2>
        <div className="search-container">
          <input
            type="text"
            placeholder="Search Solutions"
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>
      </div>

      <table className="user-types-table">
        <thead>
          <tr>
            <th>
              <MdAdd size={24} color="#1e3c72" onClick={handleAddNew} />
            </th>
            <th>Solution Name</th>
            <th>Description</th>
            <th>Created By</th>
            <th>Created Date</th>
            <th>Edited By</th>
            <th>Edited Date</th>
          </tr>
        </thead>
        <tbody>
          {filteredSolutions.map((solution, index) => (
            <tr key={solution.id}>
              <td>
                <FaEdit
                  size={15}
                  style={{ cursor: 'pointer', color: '#00bfa5' }}
                  onClick={() => handleEditSolution(index)}
                />
                <FaTrash
                  size={15}
                  color="#f44336"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleDeleteSolution(index)}
                />
              </td>
              <td>{solution.name}</td>
              <td>{solution.description}</td>
              <td>{solution.createdBy}</td>
              <td>{solution.createdDate}</td>
              <td>{solution.editedBy}</td>
              <td>{solution.editedDate}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {editModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Edit Solution</h3>
              <input
                type="text"
                value={editName}
                onChange={(e) => setEditName(e.target.value)}
              />
            <div className="modal-actions">
              <button onClick={handleSaveEdit}>Save</button>
              <button onClick={() => setEditModalOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {confirmDelete && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Are you sure you want to delete this solution?</h3>
            <div className="modal-actions">
              <button onClick={handleConfirmDelete}>Yes, Delete</button>
              <button onClick={handleCancelDelete}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Add New Solution</h3>
              <input
                placeholder='Enter Solution'
                type="text"
                value={solutionsInput[0]}
                onChange={(e) => {
                  const updatedSolutions = [...solutionsInput];
                  updatedSolutions[0] = e.target.value;
                  setSolutionsInput(updatedSolutions);
                }}
              />
            
            <div className="modal-actions">
              <button onClick={handleSaveNew}>Save</button>
              <button onClick={handleModalClose}>Close</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Solutions;
